module.exports = __webpack_public_path__ + "static/img/articleLayoutOn.792b1191.svg";